<script>
    import BaseDialog from './BaseDialog.svelte';

    let {
        dialogRef = $bindable(),
        onKeydown = null,
        helpScreenMiniCss = ""
    } = $props();

    function focus(x) { x.focus(); }
</script>

<BaseDialog bind:dialogRef={dialogRef} size={helpScreenMiniCss} title="Playback Controls" {onKeydown} showClose={false}>
    {#snippet children({ dialog })}
        <!-- svelte-ignore a11y_no_noninteractive_tabindex -->
        <!-- svelte-ignore a11y_no_static_element_interactions -->
        <div use:focus tabindex="0" onkeydown={onKeydown} class="p-6 outline-none">
            <div class="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-6">
                <p class="text-sm text-amber-900">
                    Press <kbd class="px-2 py-1 bg-white rounded text-amber-900 font-mono text-xs shadow-sm">h</kbd> to return to the main menu
                </p>
            </div>

            <div class="space-y-2">
                <div class="flex items-start p-3 bg-gray-50 rounded-lg">
                    <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-gray-900 font-mono text-sm mr-4 shadow-sm min-w-[60px] text-center">s</kbd>
                    <span class="text-gray-700">Stop playback</span>
                </div>
                <div class="flex items-start p-3 bg-gray-50 rounded-lg">
                    <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-gray-900 font-mono text-sm mr-4 shadow-sm min-w-[60px] text-center">c</kbd>
                    <span class="text-gray-700">Play from cursor</span>
                </div>
                <div class="flex items-start p-3 bg-gray-50 rounded-lg">
                    <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-gray-900 font-mono text-sm mr-4 shadow-sm min-w-[60px] text-center">[</kbd>
                    <span class="text-gray-700">Play from beginning of selection</span>
                </div>
                <div class="flex items-start p-3 bg-gray-50 rounded-lg">
                    <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-gray-900 font-mono text-sm mr-4 shadow-sm min-w-[60px] text-center">]</kbd>
                    <span class="text-gray-700">Play from end of selection</span>
                </div>
            </div>
        </div>
    {/snippet}
</BaseDialog>
